import { BaseFunctionService } from './BaseFunctionService';

export interface IItemVenda {
     id_produto: number;
     quantidade: number;
     valor_unitario: number;
}

export interface IVendaResult {
     success: boolean;
     message: string;
     venda_id?: number;
     numero_venda?: string;
     valor_total?: number;
     valor_final?: number;
     saldo_anterior_aluno?: number;
     saldo_atual_aluno?: number;
     itens_processados?: number;
}

/**
 * Serviço para funções relacionadas a vendas
 */
export class VendaFunctionsService extends BaseFunctionService {
     
     /**
      * Processa uma venda completa (pessoa, itens, pagamento)
      */
     async processarVenda(
          idPessoa: number,
          idOperador: number,
          idOrganizacao: number,
          itens: IItemVenda[],
          desconto: number = 0,
          observacoes?: string
     ): Promise<IVendaResult> {
          return await this.rpc('fn_processar_venda', {
               p_id_pessoa: idPessoa,
               p_id_operador: idOperador,
               p_id_organizacao: idOrganizacao,
               p_itens: JSON.stringify(itens),
               p_desconto: desconto,
               p_observacoes: observacoes
          });
     }
}

// Instância singleton
export const vendaFunctionsService = new VendaFunctionsService();
